import { createReducer } from '@reduxjs/toolkit';
import { clearAllProjectData } from '../actions/clearAllProjectData';
import resetCalculationDataForDocument from '../actions/resetCalculationDataForDocument';
import { timePeriodMetadataIngested } from '../actions/timePeriodMetadataIngested';
import { TIME_PERIOD_FLAGS_KEY } from '../utilities/constants';

const isInvalidTableViewPayload = (payload) =>
  payload === undefined ||
  payload.documentCode === undefined ||
  payload.timePeriodFlags === undefined;

const timePeriodMetadataByDocument = createReducer(
  {},
  {
    [timePeriodMetadataIngested]: (state, action) => {
      if (isInvalidTableViewPayload(action.payload)) {
        return state;
      }

      const { documentCode, timePeriodFlags } = action.payload;

      return {
        ...state,
        [documentCode]: {
          ...state[documentCode],
          [TIME_PERIOD_FLAGS_KEY]: timePeriodFlags,
        },
      };
    },
    [resetCalculationDataForDocument]: (state, action) => {
      if (!action.payload || !action.payload.documentCode) {
        return state;
      }
      const { documentCode } = action.payload;
      delete state[documentCode];
      return state;
    },
    [clearAllProjectData]: () => ({}),
  }
);

export default timePeriodMetadataByDocument;
